import React from "react";

export default function TextArea({
  id,
  name,
  className,
  placeholder,
  value,
  onChange,
  ...others
}) {
  return (
    <textarea
      id={id}
      name={name}
      className={className}
      placeholder={placeholder}
      required
      value={value}
      onChange={onChange}
      {...others}
    ></textarea>
  );
}
